import { API } from "@/app/api";
import { IResponseWithStatus } from "@/data/api/auth-data";
import {
  getResponseStatus,
  normalizeErrorStatus,
  postApi,
} from "./post-api";

export async function logOut(
  sessionId: string,
  successCallback: () => void,
  errorCallback: (status: string) => void
) {
  // fetch(API.Auth.userLogout, {
  //   method: "POST",
  //   body: JSON.stringify({
  //     id: sessionId,
  //   }),
  // })
  await postApi<IResponseWithStatus>(API.Auth.userLogout, { id: sessionId })
    .then((response) => {
      if (response && response.status == API.Status.Success) {
        successCallback();
      } else {
        errorCallback(getResponseStatus(response));
      }
    })
    .catch((reason) => {
      console.warn(`logOut catch error: ${reason}`);
      errorCallback(normalizeErrorStatus(reason));
    });
}
